function formatDateTime(dateValue) {
  return new Intl.DateTimeFormat('ko-KR', {
    month: 'short',
    day: 'numeric',
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(new Date(dateValue));
}

function isVoteOpen(schedule) {
  const now = new Date();
  const voteEndDate = schedule?.voteEndAt ? new Date(schedule.voteEndAt) : null;
  if (!voteEndDate || Number.isNaN(voteEndDate.getTime())) {
    return false;
  }

  const voteStartDate = schedule?.voteStartAt ? new Date(schedule.voteStartAt) : null;
  if (!voteStartDate || Number.isNaN(voteStartDate.getTime())) {
    return now <= voteEndDate;
  }

  return voteStartDate <= now && now <= voteEndDate;
}

function getVoteSummary(schedule) {
  const votes = Object.values(schedule.votes || {});
  const attendCount = votes.filter((vote) => vote === 'ATTEND').length;
  const absentCount = votes.filter((vote) => vote === 'ABSENT').length;
  return { attendCount, absentCount };
}

function ScheduleVoteCard({ schedule, currentUserId, onOpenDetail, onVote, isVoting = false }) {
  // 카드 단에서 집계/내 응답을 계산해 목록과 캘린더에서 재사용한다.
  const voteSummary = getVoteSummary(schedule);
  const voteOpen = isVoteOpen(schedule);
  const myVote = (schedule.votes || {})[currentUserId];
  const isVoteDisabled = !voteOpen || isVoting;
  const handleOpenDetail = () => {
    onOpenDetail(schedule.id);
  };
  const handleVoteClick = (event, voteType) => {
    event.stopPropagation();
    onVote(schedule.id, voteType);
  };
  const handleCardKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleOpenDetail();
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleOpenDetail}
      onKeyDown={handleCardKeyDown}
      className="rounded-2xl border border-[#dbe4f4] bg-white px-4 py-4 text-left transition hover:bg-[#f9fafb] focus:outline-none focus:ring-2 focus:ring-[#111827]/20"
    >
      <div className="relative pr-[116px]">
        <div>
          <p className="m-0 text-xs font-semibold tracking-wide text-[#475467]">{schedule.category}</p>
          <p className="mt-1 text-base font-semibold text-[#101828]">{schedule.title}</p>
          <div className="mt-2 space-y-1 text-sm text-[#475467]">
            <p className="m-0">
              일시 : {formatDateTime(schedule.startsAt)} ~{' '}
              {schedule.endsAt ? formatDateTime(schedule.endsAt) : '-'}
            </p>
            <p className="m-0">장소 : {schedule.venueName || '-'}</p>
            <p className="m-0">
              주소 : {schedule.address || '-'}
              {schedule.detailAddress ? ` (${schedule.detailAddress})` : ''}
            </p>
            <p className="m-0 text-xs text-[#667085]">
              투표 마감 : {formatDateTime(schedule.voteEndAt)}까지
            </p>
          </div>
        </div>
        <span
          className={`absolute right-0 top-0 rounded-full px-2 py-1 text-xs font-semibold ${
            voteOpen ? 'bg-[#ecfdf3] text-[#027a48]' : 'bg-[#f2f4f7] text-[#475467]'
          }`}
        >
          {voteOpen ? '투표 진행중' : '투표 마감/예정'}
        </span>
      </div>

      <div className="mt-3 flex flex-wrap items-center gap-2">
        <button
          type="button"
          disabled={isVoteDisabled}
          onClick={(event) => handleVoteClick(event, 'ATTEND')}
          className={`h-9 rounded-lg px-3 text-sm font-semibold ${
            myVote === 'ATTEND'
              ? 'bg-[#027a48] text-white'
              : 'border border-[#a6f4c5] bg-[#ecfdf3] text-[#027a48]'
          } disabled:cursor-not-allowed disabled:opacity-50`}
        >
          참여
        </button>
        <button
          type="button"
          disabled={isVoteDisabled}
          onClick={(event) => handleVoteClick(event, 'ABSENT')}
          className={`h-9 rounded-lg px-3 text-sm font-semibold ${
            myVote === 'ABSENT'
              ? 'bg-[#b42318] text-white'
              : 'border border-[#fecdca] bg-[#fef3f2] text-[#b42318]'
          } disabled:cursor-not-allowed disabled:opacity-50`}
        >
          불참
        </button>
        {isVoting && <span className="text-xs font-semibold text-[#667085]">저장 중...</span>}
        <span className="ml-auto text-sm text-[#475467]">
          참여 {voteSummary.attendCount}명 | 불참 {voteSummary.absentCount}명
        </span>
      </div>
    </div>
  );
}

export default ScheduleVoteCard;
